import { render, staticRenderFns } from "./affiliate.vue?vue&type=template&id=f39b65a6&scoped=true"
import script from "./affiliate.vue?vue&type=script&lang=js"
export * from "./affiliate.vue?vue&type=script&lang=js"
import style0 from "./affiliate.vue?vue&type=style&index=0&id=f39b65a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39b65a6",
  null
  
)

export default component.exports